import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function CourseCard({ course, index = 0, detailed = false, onView }) {
  const openDetails = () => onView?.(course);
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.6, delay: (index % 3) * 0.12, ease: [0.16, 1, 0.3, 1] }}
      className="group bg-white rounded-2xl border border-ink/10 overflow-hidden hover:border-ink/25 hover:shadow-[0_18px_50px_-20px_rgba(27,42,74,0.35)] transition-[border-color,box-shadow] duration-300"
      data-testid={`course-card-${course.id}`}
    >
      <div className="relative h-44 overflow-hidden">
        <img
          src={course.image}
          alt={course.alt}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
        />
        <span className="absolute top-3 left-3 text-[10px] tracking-[0.2em] bg-paper/90 text-ink px-2.5 py-1 rounded-full font-extrabold">
          {String(index + 1).padStart(2, "0")}
        </span>
      </div>
      <div className="p-5">
        <p className="text-[10px] tracking-[0.25em] text-brand font-bold uppercase">{course.tag}</p>
        <h3 className="font-body font-extrabold text-xl mt-1.5 text-ink">{course.name}</h3>
        <p className="text-sm text-muted leading-relaxed mt-2">{course.desc}</p>
        {detailed && (
          <ol className="mt-4 space-y-1.5 border-t border-dashed border-ink/15 pt-4">
            {course.levels.map((lvl, i) => (
              <li key={lvl} className="flex items-center gap-2.5 text-xs text-ink/70">
                <span className="text-[10px] text-brand font-bold">L{i + 1}</span> {lvl}
              </li>
            ))}
          </ol>
        )}
        <p className="mt-4 text-xs font-semibold text-teal">Start with 2 free sessions. Pay only if you love it.</p>
        <div className="mt-3 flex flex-wrap items-center gap-3">
          <Link
            to={`/play-first-pay-later?course=${encodeURIComponent(course.name)}`}
            data-testid={`course-card-${course.id}-cta`}
            className="inline-flex items-center gap-1.5 rounded-full bg-brand text-white text-xs font-bold px-4 py-2.5 hover:bg-ink transition-colors duration-300"
          >
            Book Your 2 Trial Sessions
          </Link>
          <button
            onClick={openDetails}
            data-testid={`course-card-${course.id}-details`}
            className="text-sm font-semibold text-ink group-hover:text-brand transition-colors"
          >
            View Memberships
          </button>
        </div>
      </div>
    </motion.div>
  );
}
